import axios from 'axios';

export const initAxios = () => {
  const ENVIRONMENT = process.env.ENVIRONMENT || 'development';
  const baseURLProduction = "https://produktkatalog.dew21.de";
  const baseURLIntegration = "http://dew21.adesso-dx-uxb.de";
  const baseURLTest = "http://dew-dikat-dev01.test-server.ag";
  const baseURLDevelop = "http://localhost:3002";
  const baseURL = (() => {
    switch (ENVIRONMENT) {
      case 'production':
        return baseURLProduction;
      case 'integration':
        return baseURLIntegration;
      case 'test':
        return baseURLTest;
      default:
      case 'development':
        return baseURLDevelop;
    }
  })();

  // intercept axios requests
  axios.interceptors.request.use((config) => {
    const { ...headers } = config.headers || {};
    return {
      ...config,
      headers,
      url: config.url?.startsWith('/api') ? `${baseURL}${config.url}` : config.url,
    }
  });
}
